import React from 'react';
import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import Password from 'components/Password';
import api from 'api';
import { Link } from 'react-router-dom';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import { notice } from 'ducks/notifications';
import OperationButton from 'components/OperationButton';
import { query } from 'redux-bees';

@connect()

@query('wpUsers', api.getWpUsers, (perform, props) => (
  perform({ siteId: props.site.id })
))

export default class Services extends Component {
  static propTypes = {
    site: PropTypes.object.isRequired,
    wpUsers: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  }

  @autobind
  handleStart() {
    const { dispatch, site } = this.props;

    return dispatch(api.startSite({ id: site.id }, null))
    .catch(() => dispatch(notice('Error')));
  }

  @autobind
  handleStop() {
    const { dispatch, site } = this.props;

    return dispatch(api.stopSite({ id: site.id }, null))
    .catch(() => dispatch(notice('Error')));
  }

  pmaUrl(site) {
    if (site.attributes.k8s) {
      return 'https://phpmyadmin.admin.hardypress.com';
    }
    return 'https://phpmyadmin.hardypress.com';
  }

  renderWordpress(site) {
    return (
      <div>
        <table>
          <tbody>
            <tr>
              <th>URL:</th>
              <td>
                {
                  site.attributes.wpState === 'running' ?
                    <a
                      href={site.attributes.secureAdminUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {site.attributes.adminUrl}
                    </a>
                  :
                    <span>{site.attributes.adminUrl}</span>
                }
              </td>
            </tr>
            <tr>
              <th>Admin URL:</th>
              <td>
                {
                  site.attributes.wpState === 'running' ?
                    <a
                      href={`${site.attributes.secureAdminUrl}/wp-login.php`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`${site.attributes.adminUrl}/wp-login.php`}
                    </a>
                  :
                    <span>{`${site.attributes.adminUrl}/wp-login.php`}</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderPma(site) {
    return (
      <div>
        <table>
          <tbody>
            <tr>
              <th>URL:</th>
              <td>
                {
                  site.attributes.wpState === 'running' ?
                    <a href={this.pmaUrl(site)} target="_blank" rel="noopener noreferrer">
                      {this.pmaUrl(site)}
                    </a>
                  :
                    <span>{this.pmaUrl(site)}</span>
                }
              </td>
            </tr>
            <tr>
              <th>Username:</th>
              <td>{site.attributes.dbAndUserName}</td>
            </tr>
            <tr>
              <th>Password:</th>
              <td>
                {
                  site.attributes.wpState === 'running' ?
                    <Password password={site.attributes.mysqlWpPassword} />
                  :
                    <span>*********</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderSftp(site) {
    return (
      <div>
        <table>
          <tbody>
            <tr>
              <th>Host:</th>
              <td>{site.attributes.sftpDomain}</td>
            </tr>
            <tr>
              <th>Port:</th>
              <td>{site.attributes.sftpPort}</td>
            </tr>
            <tr>
              <th>Username:</th>
              <td>{site.attributes.dbAndUserName}</td>
            </tr>
            <tr>
              <th>Password:</th>
              <td>
                {
                  site.attributes.wpState === 'running' ?
                    <Password password={site.attributes.sftpPassword} />
                  :
                    <span>*********</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { site, wpUsers } = this.props;
    const users = wpUsers && wpUsers.map(wpUser => wpUser.attributes.wpUsername).join(', ');

    return (
      <div>
        <div className="Deploys__bar">
          <div className="Deploys__bar__left">
            Through this button
            you can access a special login page where your WordPress
            users can authenticate themselves and access WordPress even if it is turned OFF.
            Share this link with the editors of this website.

            {' '}
            <Tooltip label="Click for help">
              <a href="https://www.hardypress.com/guides/how-to-use-hardypress-as-final-client/" target="_blank" rel="noopener noreferrer">
                <i className="icon--question-circle" />
              </a>
            </Tooltip>
          </div>
          <div className="Deploys__bar__right">
            <Tooltip label={`Users enabled: ${users}`}>
              <Link
                to={site.attributes.wpLoginUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="button button--secondary"
              >
                Log into WordPress
              </Link>
            </Tooltip>
          </div>
        </div>
        {
          site.attributes.wpState === 'paused' &&
            <div className="Deploys__bar">
              <div className="Deploys__bar__left">
                Your WordPress instance is currently paused.
                The following services are only available when WordPress switched ON.
              </div>
              <div className="Deploys__bar__right">
                <OperationButton
                  onClick={this.handleStart}
                  className="button"
                  label={['Switch WordPress ON']}
                />
              </div>
            </div>
        }
        {
          site.attributes.wpState === 'running' &&
            <div className="Deploys__bar">
              <div className="Deploys__bar__left">
                Your WordPress instance is currently running. To enhance your security
                we will be automatically switch it OFF after 15 minutes of inactivity.
              </div>
              <div className="Deploys__bar__right">
                <OperationButton
                  onClick={this.handleStop}
                  className="button"
                  label={['Switch WordPress OFF']}
                />
              </div>
            </div>
        }

        <div className={`Site__content ${site.attributes.wpState !== 'running' ? 'is-grayed-out' : ''}`}>
          <div className="Site__area">
            <div className="Site__area__header">
              <div className="Site__area__header__title">
                WordPress
              </div>
            </div>
            <div className="Site__area__content">
              { this.renderWordpress(site) }
            </div>
          </div>

          <div className="Site__area">
            <div className="Site__area__header">
              <div className="Site__area__header__title">
                SFTP
              </div>
            </div>
            <div className="Site__area__content">
              { this.renderSftp(site) }
            </div>
          </div>

          <div className="Site__area">
            <div className="Site__area__header">
              <div className="Site__area__header__title">
                PhpMyAdmin
              </div>
            </div>
            <div className="Site__area__content">
              { this.renderPma(site) }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Services.jsx